import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Menu, MenuItem } from '@material-ui/core'
import { ChevronDown, MapPin, Trash2, Power, Wrench } from 'lucide-react'
import { Button } from '../../root/components/common'
import { useSelector } from 'react-redux'

const useStyles = makeStyles(theme => ({
    menuItem: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        fontSize: 14
    },
    iconButton: {
        margin: theme.spacing(1)
    }
}))

export const DevicesMultiselectMenu = ({
    selectedRowsAmount,
    setIsMovingToLocationModalOpen,
    setIsDeleteDevicesModalOpen,
    setIsSwitchOffModalOpen,
    setIsMModeDevicesModalOpen
}) => {
    const classes = useStyles()
    const theme = useSelector(state => state.main.theme)
    const locale = useSelector(state => state.main.locale)
    const [anchorEl, setAnchorEl] = useState(null)

    const handleClick = event => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleMoveToLocation = () => {
        setIsMovingToLocationModalOpen(true)
        handleClose()
    }

    const handleDeleteDevices = () => {
        setIsDeleteDevicesModalOpen(true)
        handleClose()
    }

    const handleSwitchOff = () => {
        setIsSwitchOffModalOpen(true)
        handleClose()
    }

    const handleMModeDevices = () => {
        setIsMModeDevicesModalOpen(true)
        handleClose()
    }

    return (
        <>
            <Button reverted onClick={handleClick}>
                {locale.devices.devicesSelected}: {selectedRowsAmount}
                <ChevronDown
                    size={20}
                    color={theme.primary}
                    style={{ marginLeft: 16 }}
                />
            </Button>
            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem
                    onClick={handleMoveToLocation}
                    className={classes.menuItem}
                >
                    {locale.devices.moveToLocation}
                    <MapPin
                        size={20}
                        color={theme.primary}
                        style={{ marginLeft: 16 }}
                    />
                </MenuItem>
                <MenuItem
                    onClick={handleDeleteDevices}
                    className={classes.menuItem}
                >
                    {locale.devices.delete}
                    <Trash2
                        size={20}
                        color={theme.primary}
                        style={{ marginLeft: 16 }}
                    />
                </MenuItem>
                <MenuItem
                    onClick={handleSwitchOff}
                    className={classes.menuItem}
                >
                    {locale.devices.setOffline}
                    <Power
                        size={20}
                        color={theme.primary}
                        style={{ marginLeft: 16 }}
                    />
                </MenuItem>
                <MenuItem
                    onClick={handleMModeDevices}
                    className={classes.menuItem}
                >
                    {locale.common.switchOnMMode}
                    <Wrench
                        size={20}
                        color={theme.primary}
                        style={{ marginLeft: 16 }}
                    />
                </MenuItem>
            </Menu>
        </>
    )
}
